export const MAX_COLUMNS = 3;
